import React from "react";
import { Phone, Sparkles } from "lucide-react";
import { useSiteConfig } from "../lib/siteConfig";
import { openWhatsApp, callPhone, defaultWhatsAppMessage } from "../lib/whatsapp";
import { WhatsAppIcon } from "./Header";
import InstantQuoteDialog from "./InstantQuoteDialog";
import { useFixedActionsVisible } from "./FloatingButtons";

/**
 * Fixed bottom action bar visible only on mobile viewports (<md).
 * Compact mobile contact actions are hidden around forms, dialogs and footer.
 * The reserved spacer keeps the final page content clear of the bar.
 */
export default function MobileBookBar() {
    const config = useSiteConfig();
    const visible = useFixedActionsVisible();

    return (
        <>
            {/* Spacer so content isn't hidden behind the fixed bar */}
            <div aria-hidden className="h-16 md:hidden" />
            <div
                data-testid="mobile-book-bar"
                className={`${visible ? "" : "hidden"} fixed inset-x-0 bottom-0 z-40 border-t border-brand-navy/10 bg-white/95 shadow-[0_-8px_24px_-8px_rgba(0,0,0,0.15)] backdrop-blur md:hidden`}
            >
                <div className="grid grid-cols-3">
                    <button
                        type="button"
                        data-testid="mobile-book-call"
                        onClick={() => callPhone(config.phone, "mobile-book-bar")}
                        className="flex flex-col items-center justify-center gap-0.5 py-2.5 text-brand-navy transition active:bg-brand-navy/5"
                        aria-label="Call VVPSS"
                    >
                        <Phone className="h-5 w-5" />
                        <span className="text-[11px] font-bold uppercase tracking-widest">Call</span>
                    </button>
                    <button
                        type="button"
                        data-testid="mobile-book-whatsapp"
                        onClick={() =>
                            openWhatsApp(config.whatsapp, defaultWhatsAppMessage(), "mobile-book-bar")
                        }
                        className="flex flex-col items-center justify-center gap-0.5 border-x border-brand-navy/10 py-2.5 text-brand-whatsapp transition active:bg-brand-whatsapp/5"
                        aria-label="WhatsApp VVPSS"
                    >
                        <WhatsAppIcon className="h-5 w-5" />
                        <span className="text-[11px] font-bold uppercase tracking-widest">WhatsApp</span>
                    </button>
                    <InstantQuoteDialog
                        trigger={
                            <button
                                type="button"
                                data-testid="mobile-book-now"
                                className="flex flex-col items-center justify-center gap-0.5 bg-brand-gold py-2.5 text-brand-navy transition active:brightness-95"
                                aria-label="Request a Quote"
                            >
                                <Sparkles className="h-5 w-5" />
                                <span className="text-[11px] font-black uppercase tracking-widest">Get Quote</span>
                            </button>
                        }
                    />
                </div>
            </div>
        </>
    );
}
